import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AccountBasicData } from 'src/app/models/account/account-basic-data.model';
import { GeographicalLocation } from 'src/app/models/localization/geographical-location.model';
import { LocalizationService } from 'src/app/services/localization.service';

@Component({
  selector: 'notification-address-section',
  templateUrl: './notification-address-section.component.html',
  styleUrls: ['./notification-address-section.component.scss']
})
export class NotificationAddressSectionComponent implements OnInit {
  /**Es cliente? */
  @Input() isClient: boolean;
  /*Lista de departamentos para la dirección de ocurrencia del reclamo*/
  departmentList: GeographicalLocation[] = [];
  /*Lista de provincias para la dirección de ocurrencia del reclamo */
  provinceList: GeographicalLocation[] = [];
  /*Lista de distritos para la dirección de ocurrencia del reclamo */
  districtList: GeographicalLocation[] = [];
  saveDireccion: string;
  formGroup: FormGroup;
  constructor(private formBuilder: FormBuilder,
    private localizationService: LocalizationService) { }

  ngOnInit() {
    this.createForm();
    this.listDepartments();
    if (this.isClient) this.formGroup.get('firstNotificationAddress').disable();
    this.toggleSecondNotificationAddressSection();
    this.toggleEmailNotification();
  }
  createForm() {
    if (this.isClient) {
      this.formGroup = this.formBuilder.group({
        firstNotificationAddress: ['', [Validators.required]],
        includeSecondNotificationAddress: [],
        emailNotificationAddress: [],
        secondNotificationAddress: this.formBuilder.group({
          description: [, [Validators.required]],
          departmentCode: [, [Validators.required]],
          districtCode: [, [Validators.required]],
          provinceCode: [, [Validators.required]],
          reference: [, [Validators.required]]
        }),
        emailAddressNotification: this.formBuilder.group({
          emailAddress: [, [Validators.required]]
        })
      });
    }
    else {
      this.formGroup = this.formBuilder.group({
        firstNotificationAddress: ['', [Validators.required]],
        includeSecondNotificationAddress: [],
        emailNotificationAddress: [],
        secondNotificationAddress: this.formBuilder.group({
          description: [, [Validators.required]],
          departmentCode: [, [Validators.required]],
          districtCode: [, [Validators.required]],
          provinceCode: [, [Validators.required]],
          reference: [, [Validators.required]]
        }),
        emailAddressNotification: this.formBuilder.group({
          emailAddress: [, [Validators.required]]
        })
      });
    }
  }
  fillForm(accountBasicData: AccountBasicData) {
    /* this.formGroup.patchValue({
       firstNotificationAddress:
         accountBasicData.supplyAddress.streetType + ' ' +
         accountBasicData.supplyAddress.streetDescription + ' ' +
         accountBasicData.supplyAddress.streetNumber
     })
 */
    const DIR_CONCAT = (accountBasicData.supplyAddress.streetType + ' ' +
      accountBasicData.supplyAddress.streetDescription + ' ' +
      accountBasicData.supplyAddress.streetNumber);

    this.formGroup.patchValue({
      firstNotificationAddress:
        accountBasicData.dirsum ? accountBasicData.dirsum : DIR_CONCAT
    })
  }
  async listDepartments() {
    await this.localizationService.listDepartments().subscribe(response => {
      this.departmentList = response.data.filter(x => x.gis);
    });
  }
  async listProvinces(preSelectedProvince?: string) {
    await this.localizationService.listProvinces(this.formGroup.get('secondNotificationAddress').get('departmentCode').value).subscribe(response => {
      this.provinceList = response.data.filter(x => x.gis);
      if (preSelectedProvince) this.formGroup.get('secondNotificationAddress').get('provinceCode').patchValue(preSelectedProvince);
      this.districtList = [];
    })
  }
  async listDistricts(preSelectedDistrict?: string) {
    await this.localizationService.listDistricts(this.formGroup.get('secondNotificationAddress').get('provinceCode').value).subscribe(response => {
      this.districtList = response.data.filter(x => x.gis);
      if (preSelectedDistrict) this.formGroup.get('secondNotificationAddress').get('districtCode').patchValue(preSelectedDistrict);
    })
  }
  toggleSecondNotificationAddressSection() {
    if (this.formGroup.get('includeSecondNotificationAddress').value) {
      this.formGroup.get('secondNotificationAddress').enable();
      this.formGroup.get('emailNotificationAddress').disable();

    }
    else {
      this.formGroup.get('emailNotificationAddress').enable();
      this.formGroup.get('secondNotificationAddress').disable();
    }
  }
  toggleEmailNotification() {
    if (this.formGroup.get('emailNotificationAddress').value) {
      this.formGroup.get('emailAddressNotification').enable();
      this.saveDireccion = this.formGroup.get('firstNotificationAddress').value;
      this.formGroup.get('firstNotificationAddress').setValue('');
      this.formGroup.get('includeSecondNotificationAddress').disable();
    }
    else {
      this.formGroup.get('includeSecondNotificationAddress').enable();

      this.formGroup.get('emailAddressNotification').get('emailAddress').setValue('');
      this.formGroup.get('emailAddressNotification').disable();
      this.formGroup.get('firstNotificationAddress').setValue(this.saveDireccion);
    }
  }

  public addressConcat() {

    let address = "";

    if (this.formGroup.get('includeSecondNotificationAddress').value == true) {
      const secondNotificationAddress = this.formGroup.get('secondNotificationAddress');

      address = secondNotificationAddress.get('description').value ? secondNotificationAddress.get('description').value : '';
      address += (secondNotificationAddress.get('departmentCode').value ? ', ' + (this.departmentList.find(x => x.code == secondNotificationAddress.get('departmentCode').value).description) : '')
      address += (secondNotificationAddress.get('provinceCode').value ? '-' + (this.provinceList.find(x => x.code == secondNotificationAddress.get('provinceCode').value).description) : '')
      address += (secondNotificationAddress.get('districtCode').value ? '-' + (this.districtList.find(x => x.code == secondNotificationAddress.get('districtCode').value).description) : '')
      address += (secondNotificationAddress.get('reference').value ? ', ' + secondNotificationAddress.get('reference').value + ' ' : '');

    } else {
      address = this.formGroup.get('firstNotificationAddress').value;

    }

    return address;
  }
}
